import React from 'react';
import DescriptionList from 'Components/DescriptionList/DescriptionList';
import DescriptionListItem from 'Components/DescriptionList/DescriptionListItem';
import FieldSet from 'Components/FieldSet';
import Link from 'Components/Link/Link';
import PageContent from 'Components/Page/PageContent';
import PageContentBody from 'Components/Page/PageContentBody';
import { useTdarrStatus } from '../queries';

export default function Help() {
  const status = useTdarrStatus();
  return <PageContent title="Help"><PageContentBody>
    <FieldSet legend="About"><DescriptionList>
      <DescriptionListItem title="Application" data="Tdarr" /><DescriptionListItem title="Version" data={status.data?.version ?? '—'} />
      <DescriptionListItem title="Server Engine" data={status.data?.serverEngine ?? '—'} /><DescriptionListItem title="Operating System" data={status.data?.os ?? '—'} />
    </DescriptionList></FieldSet>
    <FieldSet legend="Resources"><DescriptionList>
      <DescriptionListItem title="API Documentation" data={<Link to="/api/v2/public/api-docs/json" noRouter={true}>OpenAPI JSON</Link>} />
      <DescriptionListItem title="Project" data={<Link to="https://github.com/HaveAGitGat/Tdarr">Tdarr on GitHub</Link>} />
    </DescriptionList></FieldSet>
  </PageContentBody></PageContent>;
}
